/** Record versions follow the registry epoch, never an untrusted resolver response. */
export function nextHandleEpoch(exists: boolean, value: unknown): number {
  if (!exists) return 1;
  if (
    (typeof value !== "bigint" &&
      typeof value !== "number" &&
      typeof value !== "string") ||
    (typeof value === "number" && !Number.isSafeInteger(value)) ||
    (typeof value === "string" && !/^[1-9][0-9]*$/.test(value))
  ) {
    throw new Error("Invalid on-chain handle epoch");
  }
  const epoch = BigInt(value);
  if (epoch < 1n || epoch >= BigInt(Number.MAX_SAFE_INTEGER)) {
    throw new Error("On-chain handle epoch cannot be incremented safely");
  }
  return Number(epoch + 1n);
}
